/**
 * IMPORTANT: When updating VAT validation rules in this file, make sure to also update the corresponding
 * backend validation rules in:
 * lib-platform/company-validation/src/main/kotlin/com/malt/validation/registration/number/VatCountryPatterns.kt
 *
 * All 2 files must be kept in sync to ensure consistent VAT validation across backend and frontend.
 */

const FR_VAT_EXAMPLE = 'FR12345678901';
const FR_VAT_REGEX = /^(FR)[0-9A-Z]{2}[0-9]{9}$/;

export const VAT_REGEX_BY_COUNTRIES = {
    AT: /^(AT)U[0-9]{8}$/, // Austria
    BE: /^(BE)[0-9]{9,10}$/, // Belgium
    BG: /^(BG)[0-9]{9,10}$/, // Bulgaria
    BL: FR_VAT_REGEX, // France - St. Barthélemy
    CH: /^(CHE)-?[0-9]{3}\.?[0-9]{3}\.?[0-9]{3} ?(MWST|TVA|IVA)?$/, // Switzerland
    CY: /^(CY)[0-9]{8}[A-Z]{1}$/, // Cyprus
    CZ: /^(CZ)[0-9]{8,10}$/, // CzechRepublic
    DE: /^(DE)[0-9]{9}$/, // Germany
    DK: /^(DK)[0-9]{8}$/, // Denmark
    EE: /^(EE)[0-9]{9}$/, // Estonia
    ES: /^(ES)[0-9A-Z][0-9]{7}[0-9A-Z]$/, // Spain
    FI: /^(FI)[0-9]{8}$/, // Finland
    FR: FR_VAT_REGEX, // France
    GB: /^(GB)([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/, // UnitedKingdom
    GF: FR_VAT_REGEX, // France - French Guiana
    GP: FR_VAT_REGEX, // France - Guadeloupe
    GR: /^(EL|GR)[0-9]{9}$/, // Greece
    HR: /^(HR)[0-9]{11}$/, // Croatia
    HU: /^(HU)[0-9]{8}$/, // Hungary
    IE: /^(IE)([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])$/, // Ireland
    IT: /^(IT)[0-9]{11}$/, // Italy
    LT: /^(LT)([0-9]{9}|[0-9]{12})$/, // Lithuania
    LU: /^(LU)[0-9]{8}$/, // Luxembourg
    LV: /^(LV)[0-9]{11}$/, // Latvia
    MC: FR_VAT_REGEX, // Monaco same as France
    MF: FR_VAT_REGEX, // France - St. Martin
    MQ: FR_VAT_REGEX, // France - Martinique
    MT: /^(MT)[0-9]{8}$/, // Malta
    NL: /^(NL)[0-9]{9}B[0-9]{2}$/, // Netherlands
    PL: /^(PL)[0-9]{10}$/, // Poland
    PM: FR_VAT_REGEX, // France - St. Pierre and Miquelon
    PT: /^(PT)[0-9]{9}$/, // Portugal
    RE: FR_VAT_REGEX, // France - Réunion
    RO: /^(RO)[0-9]{2,10}$/, // Romania
    SE: /^(SE)[0-9]{12}$/, // Sweden
    SI: /^(SI)[0-9]{8}$/, // Slovenia
    SK: /^(SK)[0-9]{10}$/, // Slovakia
    TF: FR_VAT_REGEX, // France - French Southern Territories
    US: /^([0-9]{9}|[0-9]{2}-[0-9]{7}|[0-9]{3}-[0-9]{2}-[0-9]{4})$/, // United States of America
    WF: FR_VAT_REGEX, // France - Wallis & Futuna
    YT: FR_VAT_REGEX, // France - Mayotte
};

export const VAT_EXAMPLES_BY_COUNTRIES = {
    AT: 'ATU66666666', // Austria
    BE: 'BE099999999', // Belgium
    BG: 'BG0000000000', // Bulgaria
    BL: FR_VAT_EXAMPLE, // France - St. Barthélemy
    CH: 'CHE319876579 MWST', // Switzerland
    CY: 'CY88888888A', // Cyprus
    CZ: 'CZ123456789', // CzechRepublic
    DE: 'DE999999999', // Germany
    DK: 'DK12345678', // Denmark
    EE: 'EE123456789', // Estonia
    ES: 'ESX9999999R', // Spain
    FI: 'FI123456789', // Finland
    FR: FR_VAT_EXAMPLE, // France
    GB: 'GB123456789', // UnitedKingdom
    GF: FR_VAT_EXAMPLE, // France - French Guiana
    GP: FR_VAT_EXAMPLE, // France - Guadeloupe
    GR: 'GR123456789', // Greece
    HR: 'HR22222222222', // Croatia
    HU: 'HU12345678', // Hungary
    IE: 'IE1111111AB', // Ireland
    IT: 'IT12345678911', // Italy
    LT: 'LT123456789', // Lithuania
    LU: 'LU12345678', // Luxembourg
    LV: 'LV12345678911', // Latvia
    MC: FR_VAT_EXAMPLE, // Monaco same as France
    MF: FR_VAT_EXAMPLE, // France - St. Martin
    MQ: FR_VAT_EXAMPLE, // France - Martinique
    MT: 'MT12345678', // Malta
    NL: 'NL123456789B44', // Netherlands
    PL: 'PL1234567891', // Poland
    PM: FR_VAT_EXAMPLE, // France - St. Pierre and Miquelon
    PT: 'PT123456789', // Portugal
    RE: FR_VAT_EXAMPLE, // France - Réunion
    RO: 'RO12345678', // Romania
    SE: 'SE123456789111', // Sweden
    SI: 'SI12345678', // Slovenia
    SK: 'SK1234567891', // Slovakia
    TF: FR_VAT_EXAMPLE, // France - French Southern Territories
    US: '12-3456789', // United States of America
    WF: FR_VAT_EXAMPLE, // France - Wallis & Futuna
    YT: FR_VAT_EXAMPLE, // France - Mayotte
};
